'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _reactGoogleMaps = require('react-google-maps');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Details = require('../Details');

var _Details2 = _interopRequireDefault(_Details);

var _pickupLocatorStyle = require('../pickupLocatorStyle.scss');

var _pickupLocatorStyle2 = _interopRequireDefault(_pickupLocatorStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var anySelected = function anySelected(props) {
  return props.locations.some(function (loc) {
    return loc.selected;
  });
};
var selected = function selected(props) {
  return props.locations.find(function (loc) {
    return loc.selected;
  });
};

var initialGeolocationRegex = /^(-?\d+(?:\.\d+)?),\s?(-?\d+(?:\.\d+)?)$/;
var matchInitialGeolocation = function matchInitialGeolocation(props) {
  return props.initialTerm && props.initialTerm.match(initialGeolocationRegex);
};
var isInitialGeolocation = function isInitialGeolocation(props) {
  return !!matchInitialGeolocation(props);
};
var getInitialGeolocation = function getInitialGeolocation(props) {
  var match = matchInitialGeolocation(props);

  var _match$slice = match.slice(1),
      _match$slice2 = (0, _slicedToArray3.default)(_match$slice, 2),
      lat = _match$slice2[0],
      lng = _match$slice2[1];

  return {
    lat: parseFloat(lat),
    lng: parseFloat(lng)
  };
};

var getCenter = function getCenter(props) {
  if (anySelected(props)) {
    var selectedLocation = selected(props);

    return {
      lat: parseFloat(selectedLocation.lat),
      lng: parseFloat(selectedLocation.lng)
    };
  }

  if (isInitialGeolocation(props)) {
    return getInitialGeolocation(props);
  }

  var firstLocation = props.locations[0];

  return {
    lat: parseFloat(firstLocation.lat),
    lng: parseFloat(firstLocation.lng)
  };
};

var Map = (0, _recompose.compose)((0, _recompose.withProps)({
  googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCi_CPkyeD6B7dSVJkij_rHcmq7U1ypQiQ&v=3.exp&libraries=geometry,drawing,places',
  loadingElement: _react2.default.createElement('div', { style: { height: '100%' } }),
  containerElement: _react2.default.createElement('div', { className: _pickupLocatorStyle2.default.mapContainer }),
  mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
}), _reactGoogleMaps.withScriptjs, _reactGoogleMaps.withGoogleMap)(function (props) {
  return _react2.default.createElement(
    _reactGoogleMaps.GoogleMap,
    {
      defaultZoom: 14,
      center: getCenter(props)
    },
    props.locations.map(function (loc) {
      return _react2.default.createElement(_reactGoogleMaps.Marker, {
        key: loc.id,
        position: { lat: loc.lat, lng: loc.lng },
        onClick: function onClick() {
          return props.selectLocation(loc.id);
        },
        icon: {
          url: loc.selected ? require('./assets/marker-selected.png') : require('./assets/marker.png'),
          // `google` global object is visible on the frontend when
          // rendering the component through `withProps()` with `googleMapURL`,
          // but it's not recognised by eslint as initialised.
          //
          // eslint-disable-next-line no-undef
          scaledSize: new google.maps.Size(40, 57),
          anchor: new google.maps.Point(20, 57)
        }
      });
    }),
    isInitialGeolocation(props) && _react2.default.createElement(_reactGoogleMaps.Marker, {
      position: getInitialGeolocation(props),
      icon: {
        url: require('./assets/your-location.png'),
        scaledSize: new google.maps.Size(100, 36), // image dimensions are 550 x 200
        anchor: new google.maps.Point(13, 36) // point at (70, 200) in original image
      },
      zIndex: 999 // google maps calculates z-index; ensure your-location is on top
    })
  );
});

var PickupLocatorMap = function PickupLocatorMap(props) {
  if (props.fetching === true) {
    return _react2.default.createElement(
      'div',
      { styleName: 'spinner' },
      'Loading...'
    );
  }

  return _react2.default.createElement(
    'div',
    null,
    anySelected(props) && _react2.default.createElement(_Details2.default, {
      details: selected(props),
      confirm: props.confirm,
      close: props.close
    }),
    props.locations.length > 0 || isInitialGeolocation(props) ? _react2.default.createElement(Map, {
      locations: props.locations,
      selectLocation: props.selectLocation,
      initialTerm: props.initialTerm
    }) : _react2.default.createElement('span', null)
  );
};

PickupLocatorMap.propTypes = {
  fetching: _react.PropTypes.bool,
  locations: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    name: _react.PropTypes.string,
    lat: _react.PropTypes.number,
    lng: _react.PropTypes.number
  })),
  selectLocation: _react.PropTypes.func.isRequired,
  initialTerm: _react.PropTypes.string
};

PickupLocatorMap.defaultProps = { locations: [] };

exports.default = (0, _reactCssModules2.default)(PickupLocatorMap, _pickupLocatorStyle2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Map/index.js
// module id = 555
// module chunks = 0